export function useHasClipboardSupport(): boolean {
  if (typeof navigator === 'undefined') {
    return false;
  }

  const isLocalhost =
    window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

  const hasClipboardSupport =
    typeof navigator.clipboard !== 'undefined' && typeof ClipboardItem !== 'undefined';

  const isSecureOrLocal = window.isSecureContext || isLocalhost;

  return hasClipboardSupport && isSecureOrLocal;
}
